import Butter from 'buttercms';

const butter = Butter('18d4a8a96ce5bbfd8eb027aa517af30a4191c03a');

export default butter;
